import { CHANGE_STATUS } from "../mutations";
import { STATUSES } from "../../components/statuses";

const leadForm = {
  state: {
    micro_phone: {
      value: '',
      status: STATUSES.EMPTY
    },
    micro_name: {
      value: '',
      status: STATUSES.EMPTY
    }

  },
  mutations: {
    [CHANGE_STATUS](state, payload) {
      state[payload.fieldName].status = payload.status;
    }
  },
  actions: {},
  getters: {}
};

export default leadForm;
